import { useMemo } from 'react';

import { ProgressBarItemMultiSubstepProps } from './ProgressBarItemMultiSubstep';

export interface ProgressBarItemMultiSubstepHook {
  first: boolean;
  last: boolean;
  finalMainStep: boolean;
  title: string;
  trackClassName: string;
  labelClassName: string;
  active: boolean;
}

export default function useProgressBarMultiSubstep(
  props: ProgressBarItemMultiSubstepProps,
): ProgressBarItemMultiSubstepHook {
  const { active, passed, first, last, finalMainStep, title } = props;

  const trackClassName = useMemo(
    () =>
      [
        'w-8 min-w-8 bg-neutral-300 flex',
        last && finalMainStep
          ? 'h-8 min-h-8 rounded-b-full'
          : 'h-[22px] min-h-[22px]',
      ]
        .filter(Boolean)
        .join(' '),
    [last, finalMainStep],
  );

  const bgColor = useMemo(() => {
    if (active) return 'bg-neutral-900';
    if (passed) return 'bg-purple-300';
    return 'bg-neutral-500';
  }, [active, passed]);

  const labelClassName = useMemo(
    () =>
      ['w-2 h-2 min-w-2 min-h-2 rounded-full mx-auto mb-auto mt-[7px]', bgColor]
        .filter(Boolean)
        .join(' '),
    [bgColor],
  );

  return {
    first,
    last,
    finalMainStep,
    title,
    trackClassName,
    labelClassName,
    active,
  };
}
